interface MessagesTabProps {
  onOpenChat: (bandName: string) => void;
}

const MessagesTab = ({ onOpenChat }: MessagesTabProps) => {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="p-4 border-b border-gray-200">
        <h2 className="font-semibold">💬 メッセージ</h2>
      </div>

      {/* Chat List */}
      <div className="divide-y divide-gray-200">
        <div
          className="p-4 hover:bg-gray-50 cursor-pointer"
          onClick={() => onOpenChat("The Rockers")}
        >
          <div className="flex items-center">
            <div className="w-12 h-12 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold mr-3">
              TR
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <h3 className="font-semibold text-gray-800">The Rockers</h3>
                <span className="text-xs text-gray-500">2分前</span>
              </div>
              <div className="text-xs text-gray-500 mb-1">
                <span className="mr-2">🎸 ロック</span>
                <span className="mr-2">📍 東京都</span>
                <span>👥 5人</span>
              </div>
              <p className="text-sm text-gray-600">
                ありがとうございます！来週の練習はいかがですか？
              </p>
            </div>
            <div className="w-2 h-2 bg-blue-500 rounded-full ml-2"></div>
          </div>
        </div>

        <div
          className="p-4 hover:bg-gray-50 cursor-pointer"
          onClick={() => onOpenChat("Jazz Collective")}
        >
          <div className="flex items-center">
            <div className="w-12 h-12 bg-gradient-to-r from-green-400 to-blue-400 rounded-full flex items-center justify-center text-white font-bold mr-3">
              JC
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <h3 className="font-semibold text-gray-800">Jazz Collective</h3>
                <span className="text-xs text-gray-500">1時間前</span>
              </div>
              <div className="text-xs text-gray-500 mb-1">
                <span className="mr-2">🎷 ジャズ</span>
                <span className="mr-2">📍 大阪府</span>
                <span>👥 4人</span>
              </div>
              <p className="text-sm text-gray-600">
                プロフィールを拝見させていただきました
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessagesTab;
